import React, { PureComponent } from 'react'
import { bool } from 'prop-types'
import paymentMethodTypes, { paymentMethodPropType } from '../paymentMethodTypes'

import './CardNumberInfo.scss'

class CardNumberInfo extends PureComponent {
  static propTypes = {
    paymentMethod: paymentMethodPropType.isRequired,

    forceShowIcon: bool,
  }

  static defaultProps = {
    forceShowIcon: false,
  }

  render() {
    const { paymentMethod, forceShowIcon } = this.props
    const info = paymentMethodTypes.convert(paymentMethod)

    const [images, imageClass, defaultShowIcon] = info.getImages()
    return (
      <div className="checkout-payments checkout__card-number">
        {(forceShowIcon || defaultShowIcon)
          && (
          <div className={`${Array.isArray(images) ? 'checkout__card-number--two ' : ''}checkout__card-number--img`}>
            {(Array.isArray(images) ? images : [images]).map(
              (image, i) => (
                <img
                  key={i}
                  src={image}
                  alt={`card ending in ${info.getLastDigits()}`}
                  className={imageClass}
                />
              ),
            )}
          </div>
          )}
        <div className="checkout__card-number--last">
          <span>****</span>
          <span className="checkout__card-number--digits">{info.getLastDigits()}</span>
        </div>
      </div>
    )
  }
}

export default CardNumberInfo
